import { getSystemSettings } from 'api/systemSettings'
import { useLoaderData } from 'react-router-dom'

export default async function loader() {
  return (await getSystemSettings(false)).systemSettings
}

export function useConfidenceConfigLoaderData() {
  return useLoaderData() as Awaited<ReturnType<typeof loader>>
}
